export const quizQuestionList = ({store}) => store.quizQuestionReducer.data;
export const quizQuestionLoading = ({store}) => store.quizQuestionReducer.loading;
export const quizQuestionError = ({store}) => store.quizQuestionReducer.error;